import { render } from "./LocationPreview.vue?vue&type=template&id=10bd8788"
import script from "./LocationPreview.vue?vue&type=script&lang=js"
export * from "./LocationPreview.vue?vue&type=script&lang=js"
script.render = render

export default script